<button type="button" (click)="scanToJpg()">Scan</button>

<div id="images"></div>